import { render, staticRenderFns } from "./goodsLink.vue?vue&type=template&id=1f53ed15&scoped=true&"
import script from "./goodsLink.ts?vue&type=script&lang=ts&"
export * from "./goodsLink.ts?vue&type=script&lang=ts&"
import style0 from "./goodsLink.vue?vue&type=style&index=0&id=1f53ed15&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53ed15",
  null
  
)

export default component.exports